const launcherCommand = (payload) => {
    console.info(`launcher:${JSON.stringify(payload)}`)
}

export const launcherOpenUrl = (url, event = undefined) => {
    if (event !== undefined && event.key !== ' ') return null

    launcherCommand({
        cmd: 'openurl',
        url,
    })
}

export const launcherGetProfiles = (serverId) => {
    launcherCommand({
        cmd: 'getprofiles',
        server: serverId,
    })
}

export const launcherSaveSettings = (settings) => {
    launcherCommand({
        cmd: 'settings',
        value: JSON.stringify(settings),
    })
}

export const launcherJavaScriptReady = (server) => {
    launcherCommand({
        cmd: 'javascriptReady',
        server,
    })
}

export const launcherOpenProfilesDialog = () => {
    launcherCommand({
        cmd: 'openprofilesdialog',
    })
}

export const launcherOpenCacheDialog = () => {
    launcherCommand({
        cmd: 'openCacheDialog',
    })
}

export const launcherQuitProcess = (serverId, userId) => {
    launcherCommand({
        cmd: 'quitprocess',
        username: userId,
        server: serverId,
    })
}

export const launcherProcessStatus = (serverId, userId) => {
    launcherCommand({
        cmd: 'processstatus',
        username: userId,
        server: serverId,
    })
}

export const launcherSetToken = (serverId, token) => {
    launcherCommand({
        cmd: 'settoken',
        server: serverId,
        token,
    })
}

export const launcherLaunchEve = (serverId, userId, profile, token) => {
    launcherCommand({
        cmd: 'launcheve',
        server: serverId,
        token,
        settingsProfile: profile,
        username: userId,
    })
}



// WEBPACK FOOTER //
// ./src/launcherBackend/launcher-command.js